import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const FlashIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 22 30"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M21.9738 13.7721c-.0379-.1603-.1147-.3087-.2238-.4321-.109-.1235-.2468-.2181-.4012-.2754l-7.2013-2.7012L15.98 1.1971c.0415-.212973.0126-.433665-.0823-.628773-.0949-.195107-.2508-.354043-.4439-.452825-.1932-.0987815-.4133-.1320484-.6271-.0947806-.2137.0372679-.4095.1430486-.5579.3013786l-14.000009 15c-.113706.1198-.1959627.2659-.2394205.4253-.0434577.1593-.0467633.327-.0096211.4879.0371422.161.1135746.3102.2224706.4344.108895.1242.246861.2195.401571.2774l7.203749 2.7012-1.8275 9.1563c-.04149.213-.01259.4337.08234.6288.09494.1951.25076.354.44394.4528.19319.0988.41327.132.62702.0948.21376-.0373.40959-.1431.55795-.3014l14.00001-15c.1116-.1198.1921-.2653.2344-.4235.0423-.1582.0451-.3244.0081-.484ZM8.67129 25.7509l1.30875-6.5475c.04686-.2323.00973-.4736-.10473-.681-.11446-.2074-.29883-.3674-.52027-.4515l-6.605-2.4813L13.3275 4.2571 12.02 10.8046c-.0468.2322-.0097.4735.1048.6809.1144.2074.2988.3674.5202.4516l6.6 2.475L8.67129 25.7509Z"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);

export default FlashIcon;
